import * as React from 'react';
import { CnRankingProps } from './types';

export const TOP_RANKING_NODE_LIST: Array<{
  label: string;
  type: CnRankingProps['topRankingStyle'];
  nodes?: React.ReactNode[];
}> = [
  {
    label: '普通',
    type: 'normal',
  },
  {
    label: '勋章',
    type: 'medal',
    nodes: [
      <img
        key={1}
        src="https://gw.alicdn.com/imgextra/i3/O1CN01jMcTL41kfgmJnKpqF_!!6000000004711-2-tps-36-36.png"
      />,
      <img
        key={2}
        src="https://gw.alicdn.com/imgextra/i3/O1CN01eBxknC1UfetmHz2Ap_!!6000000002545-2-tps-36-36.png"
      />,
      <img
        key={3}
        src="https://gw.alicdn.com/imgextra/i2/O1CN01dPyVL01G6wFh8gb0h_!!6000000000574-2-tps-36-36.png"
      />,
    ],
  },
];
